<template>
  <div class="c-recaptcha-inline">
    <div
      :id="containerId"
      data-size="invisible"
      :data-badge="position"
    />
  </div>
</template>
<script>
import { onMounted } from 'vue'

export default {
  props: {
    recaptchaKey: {
      type: String,
      required: true
    },
    containerId: {
      type: String,
      required: true
    },
    position: {
      type: String,
      default: 'bottomright'
    }
  },
  setup(props, context) {
    let widgetId = null
    const getRecaptchaApi = () => {
      const { grecaptcha } = window
      if (!grecaptcha) {
        return null
      }

      if (grecaptcha.enterprise && typeof grecaptcha.enterprise.render === 'function') {
        return grecaptcha.enterprise
      }

      if (typeof grecaptcha.render === 'function') {
        return grecaptcha
      }

      return null
    }

    const getRecaptchaResponse = (response) => {
      if (response) {
        context.emit('submit', response)
      }
    }

    const renderRecaptcha = () => {
      const recaptcha = getRecaptchaApi()
      if (recaptcha && widgetId === null) {
        widgetId = recaptcha.render(props.containerId, {
          sitekey: props.recaptchaKey,
          size: 'invisible',
          callback: getRecaptchaResponse
        })
      }
    }

    const loadRecaptchaScript = () => {
      if (getRecaptchaApi()) {
        renderRecaptcha()
        return
      }

      if (!window.recaptchaScriptPromise) {
        window.recaptchaScriptPromise = new Promise((resolve) => {
          const existingScript = document.querySelector('script[src*="recaptcha/api.js"]')

          if (existingScript) {
            if (getRecaptchaApi()) {
              resolve()
              return
            }
            existingScript.addEventListener('load', resolve, { once: true })
            return
          }

          const script = document.createElement('script')
          script.src = 'https://www.recaptcha.net/recaptcha/api.js?render=explicit'
          script.async = true
          script.defer = true
          script.addEventListener('load', resolve, { once: true })
          document.head.appendChild(script)
        })
      }

      window.recaptchaScriptPromise.then(() => {
        renderRecaptcha()
      })
    }

    window.recaptchaRenderCallbacks = window.recaptchaRenderCallbacks || []
    window.recaptchaRenderCallbacks.push(renderRecaptcha)
    window.renderCaptcha = () => window.recaptchaRenderCallbacks.forEach((cb) => cb())

    onMounted(() => {
      loadRecaptchaScript()
    })

    function verify() {
      const recaptcha = getRecaptchaApi()
      if (!recaptcha) {
        return
      }

      if (widgetId === null) {
        renderRecaptcha()
        return
      }

      const response = recaptcha.getResponse(widgetId)
      if (response.length === 0) {
        recaptcha.execute(widgetId)
      } else {
        context.emit('submit', response)
      }
    }

    return {
      verify
    }
  }
}
</script>
<style scoped>
.c-recaptcha-inline {
  margin-top: 1rem;
  position: relative;
  z-index: 20;
}
</style>
